<template>
  <div class="text-center ma-2 primary">
    <v-snackbar v-model="globalSnackbar.open" :timeout="4000" color="primary">
      {{ globalSnackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="handleClose"> X </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'Snackbar',
  data: () => ({}),
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleClose() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: false,
        text: '',
      })
    },
  },
  computed: {
    ...mapState('user', ['globalSnackbar']),
  },
}
</script>

<style></style>
